import { MFNames } from './MFNames';

export const MFFolders = {
	[MFNames.apiWebStatic]: 'api-web-static',
	[MFNames.webStaticAdmin]: 'web-static-admin',
	[MFNames.efr]: 'efr',
	[MFNames.apiEfrAdmin]: 'api-efr-admin',
	[MFNames.efrAdmin]: 'efr-admin',
	[MFNames.efrFast]: 'efr-fast',
	[MFNames.efrDrom]: 'efr-drom',
	[MFNames.efrT2]: 'efr-t2',
	[MFNames.efrCommon]: 'efr-common',
	[MFNames.apiReki]: 'api-reki',
	[MFNames.apiEfr]: 'api-efr',
	[MFNames.designTokens]: 'design-tokens',
	[MFNames.reki]: 'reki',
	[MFNames.seller]: 'seller',
	[MFNames.common]: 'common',
	[MFNames.uiKit]: 'ui-kit',
	[MFNames.webStatic]: 'web-static',
	[MFNames.staticFiles]: 'static-files',
};

export type MFFoldersKeys = keyof typeof MFFolders;

export const MFFoldersToName = Object.fromEntries(
	Object.entries(MFFolders).map((a) => a.reverse()),
) as Record<string, MFFoldersKeys>;
